module.exports = __webpack_public_path__ + "static/media/Mentorship-11.52d79fc3.jpg";